import styled from "styled-components";

export const StarDivision = styled.div` 
  padding: 1rem;

  .MuiRating-root {
    font-size: 2.5rem;
    width: 100%;
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    margin: 1rem 2rem;

    @media(max-width: 770px) {
      margin: 1rem 0rem;
    }
  }

  h3 {
    color: #0000ff;
    font-size: 1.2rem;
    font-weight: 550;
  }

  p {
    color: #5A5A5A;
    margin: 0 0 1rem 0;
  }

  h4 {
    color: #5A5A5A;
    font-weight: 550;
    font-size: 1rem;
    display: flex;
    justify-content: space-between;

    span {
      color: #9E9E9E;
      font-weight: 400;
      font-size: .8rem;
    }
  }

  textarea {
    resize: none;
    width: 100%;
    border-radius: 5px;
    border: 1.7px solid #D5D5D5;
    padding: .5rem;
    height: 6rem;
  }
`;

export const ButtonDivision = styled.div`
  display: flex;
  justify-content: center;

  button {
    border: 0;
    padding: 0.5rem;
    width: 180px;
    border-radius: 6px;
    color: white;
    background-color: ${(props) => props.children.props.active ? "#0000ff" : "#B4B4B4"};
    font-weight: 500;
    margin: 1rem 0 0 0;
    box-shadow: 0px 3px 6px #00000066;
  }
`;

export const CloseIcon = styled.div`
  display: flex;
  justify-content: flex-end;

  img {
    width: 6%;
    height: 6%;
    margin-top: -11%;
    cursor: pointer;

    @media(max-width: 770px) {
      width: 10%;
      height: 10%;
      margin-top: -17%;
    }
  }
`;

export const LoadingIcon = styled.i`
  font-size: 15px;
`;

export const Limit = styled.div`
  display: flex;
  margin: .5rem 0;

  span {
    color: #ff0000;
    opacity: .8;
  }
`;